/* eslint-disable import/prefer-default-export, key-spacing */

export const company = {
  id: 'cid',
};

export const distributor = {
  id: 'cid',
};

export const token = {
  value: 'token',
};



// WEBPACK FOOTER //
// ./src/store/types/persisted.js